/*******************************************************************************
 * Copyright (c) 2023 GetChkd
 *
 * All rights reserved.
 *
 * Contributors:
 *  James Worthington - Initial implementation
 *  Amina Rais - Massive Improvements
 *  Version: 2.0.0
 *
 *******************************************************************************/

import React, { useCallback, useEffect, useState } from 'react';
import { Grid } from '@mui/material';
import { Box } from '@mui/system';
import BackButton from '../../../../../components/shared/Buttons/BackButton';
import { useDispatch } from 'react-redux';
import Loader from '../../../../../components/ui-elements/loader';
import OrgAuthProviderCreationBtn from '../views/organization/authProviders/OrgAuthProviderCreationBtn';
import OrgAuthProvidersList from '../views/organization/authProviders/OrgAuthProvidersList';
import { getAllOrgsAuthProviders } from '../../../../../store/reducers/organization/orgAuthProvider/orgAuthProviderAction';

const ManageOrganizationsAuthProvidersPage = () => {
    const [loading, setLoading] = useState(false);
    const dispatch = useDispatch()
    const fetchOrgAuthProviders = useCallback(async () => {
        try {
            setLoading(true);
            await dispatch(getAllOrgsAuthProviders()).unwrap();
            setLoading(false)
        } catch (error) {
            setLoading(false)

        }
    }, [dispatch])
    useEffect(() => {
        fetchOrgAuthProviders()
    }, [fetchOrgAuthProviders]);

    return (
        <>
            <Box m={6}>
                <Grid container spacing={4} >
                    <Grid item xs={12} sm={12} md={12}>
                        <BackButton pageTitle={'Manage Organizations Identity Providers'} />
                    </Grid>
                    <Grid item xs={12} sm={6} md={6} />

                    <Grid item xs={12} sm={6} md={6} >
                        <OrgAuthProviderCreationBtn />
                    </Grid>

                    <Grid item xs={12} sm={12} md={12}>
                        {!loading ? <OrgAuthProvidersList /> : (<Loader />)}
                    </Grid>

                </Grid>
            </Box>

        </>
    )

}

export default ManageOrganizationsAuthProvidersPage; 